/** Visibilidade de agendamentos por membro (Fase 5 multi-agenda). */

export type AppointmentsCalendarVisibility = "all" | "assigned_only";

export interface FilterableAppointment {
  lead_id: string | null;
  google_calendar_id?: string | null;
}

export function resolveAppointmentsCalendarVisibility(
  raw: unknown,
  isAdmin: boolean,
): AppointmentsCalendarVisibility {
  if (isAdmin) return "all";
  if (raw === "assigned_only" || raw === "all") {
    return raw;
  }
  return "all";
}

/** Membro restrito a agendamentos de leads atribuídos a ele (Fase 5). */
export function usesAssignedOnlyCalendars(
  visibility: AppointmentsCalendarVisibility,
  isAdmin: boolean,
): boolean {
  return !isAdmin && visibility === "assigned_only";
}

/** Gestor/admin ou visibilidade "all" enxergam todos os agendamentos nas agendas permitidas. */
export function canSeeAllAppointmentsInCalendars(
  visibility: AppointmentsCalendarVisibility,
  isAdmin: boolean,
): boolean {
  return isAdmin || visibility === "all";
}

export function isAppointmentVisibleToMember(
  appointment: FilterableAppointment,
  opts: {
    isAdmin: boolean;
    currentMemberId: string | null | undefined;
    appointmentsCalendarVisibility: AppointmentsCalendarVisibility;
    leadAssignedMemberId?: string | null;
  },
): boolean {
  if (opts.isAdmin) return true;
  if (opts.appointmentsCalendarVisibility === "all") return true;

  if (!appointment.lead_id) return false;

  const assigned = opts.leadAssignedMemberId ?? null;
  return Boolean(
    opts.currentMemberId && assigned != null && assigned === opts.currentMemberId,
  );
}
